import Link from 'next/link';

function Categories({ title = 'Categories', categories = [] }) {
	return (
		<div className="card box">
			<div className="card-content">
				<p className="title is-4 is-family-code">{title}</p>
				<div className="content">
					{categories.map(({ tag, count }, i) => (
						<p key={i} className="has-text-weight-semibold is-size-5 is-marginless">
							<Link href={`/blog?tags=${tag}`}>{tag}</Link> ({count})
						</p>
					))}
				</div>
			</div>
		</div>
	);
}

export default Categories;
